import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";

class ConversationLog extends Component {
  constructor() {
    super();

    this.state = {
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        0, 0, 0
      ),
      endDate: new Date(),
      escalatedChecked: false,
      attendedChecked: false,
      data: [
        {
          id: "",
          text: "",
          userId: "",
          valueType: "",
          description: "",
          valueType: [],
          userId: "",
          displayName: "",
          contactNumber: "",
          preferredLanguage: "",
          escalated: "",
          attendedChecked: "",
          date: "",
          conversationId: "",
          deleteRow: false,
          time: "",
        },
      ],
      utData: [],
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      leadUtteranceListJsonModel: [],
      diableDownloadButton: false,
      maskingRequired: false,
      selectedRowId: null,
    };
    this.editImageSrc = "./assets/images/edit.svg";
    this.saveImageSrc = "./assets/images/save.svg";

    this.valueTypeVar = [];
  }

  componentDidMount() {
    var thisController = this;

    const now = new Date();
    const startOfTodayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));
    const endOfNowUTC = new Date();
    console.log("Start of today (UTC):", startOfTodayUTC.toISOString());

    thisController.setState(
      { utData: [] },
      () => {
        thisController.fetchConversationLogDataOfCurrentDay();
      }
    );

    // Event listener for project change
    document.addEventListener("projectChanged", function (event) {
      const now = new Date();
      const startOfTodayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));
      const endOfNowUTC = new Date();

      thisController.setState(
        { utData: [],
          leadUtteranceListJsonModel: [],
         },
        () => {
          thisController.projectId = event.projectId;
          thisController.fetchConversationLogData(startOfTodayUTC, endOfNowUTC, event.projectId);
        }
      );
    });
  }

  refreshData = () => {
    var conversationController = this;
    conversationController.state.leadUtteranceListJsonModel = [];
    conversationController.fetchConversationLogDataOfCurrentDay();
  };

  onChangeFromDate = (fromDate) => {
    this.state.startDate = fromDate;
    this.state.leadUtteranceListJsonModel = [];
    this.setState(this.state);
    this.fetchConversationLogData(fromDate, this.state.endDate);
  };
  onChangeToDate = (toDate) => {

    this.state.endDate = toDate;
    this.state.leadUtteranceListJsonModel = [];
    this.setState(this.state);
    this.fetchConversationLogData(this.state.startDate, toDate);
  };

  fetchConversationLogData = (
    selectedStartDate,
    selectedEndDate,
    projectId
  ) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var conversationController = this;
    const longStartDate = selectedStartDate.getTime();
    const longEndDate = selectedEndDate.getTime();

    $.ajax({
      url: "/salesdesk-api/load-conversations",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
        startDate: longStartDate,
        endDate: longEndDate,
        projectRole: localStorage.getItem("PROJECT_ROLE"),
        salesExecId: JSON.parse(localStorage.getItem("user_details")).userId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var data = res.result;
          if (data != null) {
            conversationController.state.diableDownloadButton =
              data.disableConversationDownload;
            conversationController.state.maskingRequired = data.maskingRequired;
          }
          conversationController.state.data = data.recordList;
          conversationController.state.successResp = true;
          conversationController.setState(conversationController.state);
        }
      },
    });
  };

  fetchConversationLogDataOfCurrentDay = (
    projectId
  ) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var conversationController = this;

    $.ajax({
      url: "/salesdesk-api/load-conversations-of-current-day",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
        projectRole: localStorage.getItem("PROJECT_ROLE"),
        salesExecId: JSON.parse(localStorage.getItem("user_details")).userId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var data = res.result;
          if (data != null) {
            conversationController.state.diableDownloadButton =
              data.disableConversationDownload;
            conversationController.state.maskingRequired = data.maskingRequired;
          }
          conversationController.state.data = data.recordList;
          conversationController.state.successResp = true;
          conversationController.setState(conversationController.state);
        }
      },
    });
  };

  fetchConversationLogDataByPhoneNumber = () => {
    var conversationController = this;
    var longStartDate = new Date(this.state.startDate.toDateString()).getTime();
    var longEndDate = new Date(this.state.endDate.toDateString()).getTime();

    var contactNumber = document.getElementById("contactNumber").value;
    if (!contactNumber.includes("+91")) {
      contactNumber = "+91" + contactNumber;
    }
    $.ajax({
      url: "/salesdesk-api/fetch-conversation-by-lead-number",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        startDate: longStartDate,
        endDate: longEndDate,
        leadContactNumber: contactNumber,
        projectRole: localStorage.getItem("PROJECT_ROLE"),
        salesExecId: JSON.parse(localStorage.getItem("user_details")).userId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          conversationController.setState({
            data: tagKeys.recordList,
            successResp: true,
          });
        } else {
          conversationController.notifyWarning(res.result);
        }
      },
    });
  };

  notifyWarning(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyError(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  fetchUtterancesApi = (originalProps) => {
    var utteranceController = this;
    const startDateInFromate = `${this.state.startDate.getDate()}/${this.state.startDate.getMonth() + 1
      }/${this.state.startDate.getFullYear()}`;
    const endDateInFromate = `${this.state.endDate.getDate()}/${this.state.endDate.getMonth() + 1
      }/${this.state.endDate.getFullYear()}`;
    var selectedStartDate = this.state.startDate;

    const longStartDate = Date.UTC(
      selectedStartDate.getUTCFullYear(),
      selectedStartDate.getUTCMonth(),
      selectedStartDate.getUTCDate(),
      0,
      0,
      0
    );

    $.ajax({
      url: "/salesdesk-api/fetch-utterances",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        leadId: originalProps.conversationReportId.leadId,
        startDate: longStartDate,
        endDate: this.state.endDate.getTime(),
        socialPlatform: originalProps.socialPlatform,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var leadConversation = [];
          var leadConversationObject = {};
          var date;
          for (var i = 0; i < res.result.length; i++) {
            date = new Date(res.result[i].key.time);
            leadConversationObject = {
              type: res.result[i].messageType,
              incoming: res.result[i].incoming,
              userName:
                res.result[i].incoming == true
                  ? res.result[i].leadName
                  : "Sales Executive",
              utteranceText:
                res.result[i].templateName == null
                  ? res.result[i].text == null
                    ? ""
                    : res.result[i].text
                  : "Template: " + res.result[i].templateName,
              utteranceType:
                res.result[i].incoming == true ? "Received" : "Sent",
              id: res.result[i].id,
              messageType: res.result[i].messageType,
              text: res.result[i].text,
              templateName: res.result[i].templateName,
              utteranceTime:
                utteranceController.getTime(date) +
                ", " +
                date.toLocaleDateString("en-GB"),
              messageStatus: res.result[i].messageStatus,
              incoming: res.result[i].incoming,
              errorMessage: res.result[i].errorMessage,
              socialPlatform: res.result[i].key.socialPlatform,
            };
            if (res.result[i].fileName != null) {
              (leadConversationObject.fileId = res.result[i].fileId),
                (leadConversationObject.fileName = res.result[i].fileName);
            }
            leadConversation.push(leadConversationObject);
          }
          utteranceController.state.leadUtteranceListJsonModel =
            leadConversation;

          utteranceController.setState({
            utData: res.result,
            successResp: true,
          });
        } else {
          utteranceController.notifyError("Oops! Error occurred. Please try again");
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      },
    });
  };
  downloadConversation = (originalProps) => {
    var downloadController = this;
    const startDateInFromate = `${this.state.startDate.getDate()}/${this.state.startDate.getMonth() + 1
      }/${this.state.startDate.getFullYear()}`;
    const endDateInFromate = `${this.state.endDate.getDate()}/${this.state.endDate.getMonth() + 1
      }/${this.state.endDate.getFullYear()}`;

    $.ajax({
      url: "/salesdesk-api/download-utterances/",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        leadId: originalProps.conversationReportId.leadId,
        startDate: this.state.startDate.getTime(),
        endDate: this.state.endDate.getTime(),
        socialPlatform: originalProps.socialPlatform,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          const b64Data = res.result.data;
          const blob = downloadController.b64toBlob(
            b64Data,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
            512
          );
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = res.result.fileName;
          document.body.appendChild(link);
          link.click();
        } else {
          downloadController.notifyError("Oops! Error occurred. \n Please try again");
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      },
    });
  };

  generateReport = () => {
    var reportController = this;

    $.ajax({
      url: "/salesdesk-api/generate-report",
      async: false,
      method: "POST",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        startDate: this.state.startDate.getTime(),
        endDate: this.state.endDate.getTime(),
        salesExecId: JSON.parse(localStorage.getItem("user_details")).userId,
        projectRole: localStorage.getItem("PROJECT_ROLE"),
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          const b64Data = res.result.data;
          const blob = reportController.b64toBlob(
            b64Data,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
            512
          );
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = res.result.fileName;
          document.body.appendChild(link);
          link.click();
        } else {
          reportController.notifyError("Oops! Error occurred. \n Please try again");
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      },
    });
  };

  b64toBlob = (b64Data, contentType, sliceSize) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };
  getTime = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var aa = "AM";
    if (hours < 12) {
      aa = "AM";
    } else {
      hours = Number(hours) - 12;
      aa = "PM";
    }
    if (hours == 0) {
      hours = 12;
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    return hours + ":" + minutes + " " + aa;
  };
  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  };
  handleChangeForUtterance = (originalProps) => {
    this.fetchUtterancesApi(originalProps);
    this.setState({
      text: this.state.value,
    });
  };
  handleChangeForDownload = (originalProps) => {
    this.downloadConversation(originalProps);
  };
  onKeyPressHandleChange = (event) => {
    var contactNumber = event.target.value;
    if (event.key === "Enter") {
      if (contactNumber != "" || contactNumber != undefined) {
        if (contactNumber.includes("+91")) {
          contactNumber = contactNumber.replace("+91", "");
        }
        if (contactNumber.length == 10) {
          this.fetchConversationLogDataByPhoneNumber();
        } else {
          this.notifyWarning("Oops! Please enter the proper contact number");
        }
      } else {
        this.notifyWarning("Oops! Please enter the proper contact number");
      }
    }
  };
  queryHandleChange = (event) => {
    var contactNumber = document.getElementById("contactNumber").value;
    if (contactNumber != "") {
      if (contactNumber.includes("+91")) {
        contactNumber = document
          .getElementById("contactNumber")
          .value.replace("+91", "");
      }
      if (contactNumber.length == 10) {
        this.fetchConversationLogDataByPhoneNumber();
      } else {
        this.notifyWarning("Oops! Please enter the proper contact number");
      }
    } else {
      this.notifyWarning("Oops! Please enter the proper contact number");
    }
  };

  render() {
    const { data } = this.state;
    const columns1 = [
      {
        Header: "",
        accessor: "text",
        Cell: (props) => {
          const msg = props.original;
          const isIncoming = msg.incoming === true;

          // Skip rendering if message has no content
          if (!msg.text && !msg.templateName && !msg.utteranceText && !msg.fileId) {
            return null;
          }

          // Separator message
          if (msg.isSeparator) {
            return (
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: "1rem",
                  backgroundColor: "#f0f0f0",
                  color: "#666",
                  borderRadius: "0.5rem",
                  margin: "1rem 0",
                  fontSize: "0.9rem",
                }}
              >
                {msg.label}
              </div>
            );
          }

          const fileLinkStyle = {
            textDecoration: "none",
            color: "#007bff",
            fontWeight: "bold",
          };

          const isMedia =
            msg.type === "DOCUMENT" || msg.type === "IMAGE" || msg.type === "AUDIO" || msg.type === "VIDEO";

          const containerHeight = msg.templateName
            ? "13rem"
            : isMedia
              ? "8rem"
              : "8rem";

          return (
            <div className="card-body chat_body log_one">
              <div className={isIncoming ? "direct-chat-msg right" : "direct-chat-msg"}>
                <div
                  className={
                    isIncoming
                      ? "direct-chat-text chat_right textarea"
                      : "direct-chat-text chat_left textarea"
                  }
                  style={{
                    backgroundColor: isIncoming ? "#e8eaf6" : "#e0f7fa",
                    minHeight: containerHeight,
                  }}
                >
                  <span style={{ fontWeight: "600", display: "inline-block", paddingBottom: "0.5rem", paddingRight: "0.25rem" }}>
                    {msg.userName} :
                  </span>

                  {/* Template Message */}
                  {msg.templateName ? (
                    <div className="template-message">
                      <div
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "bold",
                          marginBottom: "0.3rem",
                          // color: "#6b4f0b",
                        }}
                      >
                        📋 Template Message: {msg.templateName}
                      </div>
                    </div>
                  ) : msg.type === "TEXT" || !msg.type ? (
                    <span>
                      {msg.utteranceText && msg.utteranceText.split(/\n/).map((line, idx) => (
                        <span key={idx}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </span>
                  ) : msg.type === "DOCUMENT" ? (
                    <a
                      className="media-fade-in"
                      href={`/salesdesk-api/social/file/download?fileId=${msg.fileId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={msg.fileName}
                      style={fileLinkStyle}
                    >
                      <br />
                      <img
                        src="./assets/images/document.png"
                        alt="Document"
                        style={{ width: "2rem", verticalAlign: "middle", marginRight: "0.5rem" }}
                      />
                      {msg.fileName.length > 30
                        ? msg.fileName.slice(0, 30) + "..."
                        : msg.fileName}
                      <br />
                    </a>
                  ) : msg.type === "IMAGE" ? (
                    <a
                      className="media-fade-in"
                      href={`/salesdesk-api/social/file/download?fileId=${msg.fileId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={msg.fileName || "Image"}
                    >
                      <br />
                      <img
                        className="media-fade-in"
                        src={`/salesdesk-api/social/file/download?fileId=${msg.fileId}`}
                        alt="Image"
                        style={{ height: "auto", width: "20rem", borderRadius: "0.5rem" }}
                      />
                      <br />
                    </a>
                  ) : msg.type === "AUDIO" ? (
                    <audio
                      className="media-fade-in"
                      controls
                      title="Audio message"
                      style={{ width: "100%" }}
                    >
                      <source
                        src={`/salesdesk-api/social/file/download?fileId=${msg.fileId}`}
                      />
                      Your browser does not support the audio element.
                    </audio>
                  ) : msg.type === "VIDEO" ? (
                    <video
                      className="media-fade-in"
                      controls
                      title="Video message"
                      style={{ maxWidth: "100%", borderRadius: "0.5rem" }}
                    >
                      <source
                        src={`/salesdesk-api/social/file/download?fileId=${msg.fileId}`}
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <span>
                      {msg.utteranceText && msg.utteranceText.split(/\n/).map((line, idx) => (
                        <span key={idx}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </span>
                  )}

                  {/* Error Message */}
                  {msg.messageStatus === "ERROR" && !isIncoming && (
                    <div
                      style={{
                        padding: "0.5rem",
                        color: "red",
                        fontWeight: "500",
                        width: "fit-content",
                        marginTop: "0.5rem",
                        wordWrap: "break-word",
                        fontSize: "0.9rem",
                      }}
                      title={msg.errorMessage}
                    >
                      {msg.errorMessage}
                    </div>
                  )}

                  {/* Timestamp */}
                  <span
                    title={msg.utteranceTimeFull || msg.utteranceTime}
                    style={{
                      fontSize: "0.7rem",
                      display: "block",
                      marginTop: "0.5rem",
                      padding: "0.5rem",
                    }}
                  >
                    {msg.utteranceTime}
                  </span>

                  {/* Message Status */}
                  {!isIncoming && msg.messageStatus && (
                    <span
                      style={{
                        fontSize: "0.7rem",
                        fontWeight: "bold",
                        color:
                          msg.messageStatus === "ERROR"
                            ? "red"
                            : msg.messageStatus === "SENT"
                              ? "rgb(113 112 108)"
                              : msg.messageStatus === "DELIVERED"
                                ? "#1baf1b"
                                : "#155bc9e8",
                        position: "absolute",
                        right: "1rem",
                        bottom: "0.5rem",
                      }}
                      title={`Status: ${msg.messageStatus}`}
                    >
                      {msg.messageStatus}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
    ];

    const columns = [
      {
        Header: "",
        accessor: "leadName",
        Cell: (props) => {
          const item = props.original;
          const dateString =
            item.conversationReportId && item.conversationReportId.time
              ? new Date(item.conversationReportId.time).toISOString().split("T")[0]
              : "Date not available";
          const isSelected = this.state.selectedRowId === `${item.leadId}|${item.socialPlatform}`;

          return (
            <div
              style={{
                padding: "1rem",
                border: isSelected ? "0.125rem solidrgb(0, 0, 0)" : "0.0625rem solid #ddd",
                borderRadius: "0.5rem",
                backgroundColor: "#f8f9fa",
                marginBottom: "1rem",
                boxShadow: isSelected ? "0 0 0.5rem rgba(0, 0, 0)" : "none",
                transition: "all 0.3s ease",
              }}
            >
              <div style={{ marginBottom: "0.5rem" }}>
                <strong>User Name:</strong>{" "}
                <span style={{ marginLeft: "0.3rem", marginRight: "1rem" }}>
                  {item.leadName && item.leadName.trim() !== "" ? item.leadName : "Name not Available"}
                </span>
                <strong>Date:</strong>{" "}
                <span style={{ marginLeft: "0.3rem", marginRight: "1rem" }}>{dateString}</span>
                <strong>Social Platform:</strong>{" "}
                <span style={{ marginLeft: "0.3rem" }}>{item.socialPlatform || "N/A"}</span>
              </div>

              <div style={{ marginBottom: "0.5rem" }}>
                <strong>Contact Number:</strong>{" "}
                <span style={{ marginLeft: "0.3rem", marginRight: "1rem" }}>
                  {this.state.maskingRequired ? "XXXXXXXXXX" : item.leadContactNumber || "N/A"}
                </span>
                <strong>Sales Executive Email Id:</strong>{" "}
                <span style={{ marginLeft: "0.3rem" }}>{item.salesExecEmailId || "N/A"}</span>
              </div>

              <div style={{ textAlign: "right" }}>
                <button
                  className="btn navyblue-btn animated-btn"
                  title="View conversation"
                  style={{ borderRadius: "0.25rem", height: "2.5rem", minWidth: "10rem", marginRight: "0.5rem" }}
                  onClick={() => {
                    this.setState({ selectedRowId: `${item.leadId}|${item.socialPlatform}` });
                    this.handleChangeForUtterance(item);
                  }}
                >
                  View Conversations
                </button>
                <button
                  className="btn navyblue-btn animated-btn"
                  title="Download conversation"
                  style={{ borderRadius: "0.25rem", height: "2.5rem", minWidth: "10rem" }}
                  disabled={this.state.diableDownloadButton}
                  onClick={() => this.handleChangeForDownload(item)}
                >
                  Download conversation
                </button>
              </div>
            </div>
          );
        },
      },
    ];

    return (
      <div visible={this.state.successResp ? false : true}>
        <div
          style={{
            background: "#F9F9FB",
            marginLeft: "1%",
            marginRight: "1%",
          }}
        >
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link rel="stylesheet" href="./assets/css/react.table.border.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link href="assets/css/styles.css" rel="stylesheet" />
          {/* <div className="wrapper"> */}
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          {/* ----new style------------------------------- */}
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="dist/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <style
            media="screen"
            dangerouslySetInnerHTML={{
              __html:
                "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  ",
            }}
          />

          {/* for checkbox component */}
          <link rel="stylesheet" href="./assets/css/combobox-style.css" />
          <link
            rel="stylesheet"
            href="assets/css/Checkbox/Checkboxbutton.css"
          />
          <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />
          {/* Date Picker */}
          <link href="assets/css/customDatePicker.css" rel="stylesheet" />

          <div className="container-fluid">
            <div className="row align-items-center py-2" style={{ rowGap: '1rem' }}>

              {/* Title */}
              <div className="col-sm-3">
                <h6
                  className="nav-item mb-0"
                  style={{ color: "#282a65", fontSize: "1rem" }}
                >
                  Conversation Log
                </h6>
              </div>

              {/* FROM Date */}
              <div className="col-sm-2 date-picker-wrapper">
                <label htmlFor="fromDate" className="form-label" style={{ paddingRight: "0.5rem" }}>FROM:</label>
                <DatePicker
                  id="fromDate"
                  selected={this.state.startDate}
                  onChange={this.onChangeFromDate}
                  dateFormat="dd/MM/yyyy"
                  className="form-control custom-datepicker"
                  calendarClassName="custom-calendar"
                />
              </div>

              {/* TO Date */}
              <div className="col-sm-2 date-picker-wrapper">
                <label htmlFor="toDate" className="form-label" style={{ paddingRight: "0.5rem" }}>TO:</label>
                <DatePicker
                  id="toDate"
                  selected={this.state.endDate}
                  onChange={this.onChangeToDate}
                  dateFormat="dd/MM/yyyy"
                  className="form-control custom-datepicker"
                  calendarClassName="custom-calendar"
                />
              </div>

              {/* Search Input + Button */}
              <div className="col-sm-3">
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <input
                    type="search"
                    placeholder="Search by number"
                    onKeyPress={this.onKeyPressHandleChange}
                    id="contactNumber"
                    className="form-control"
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      backgroundColor: "white",
                      fontSize: "1rem",
                    }}
                  />
                  <button
                    onClick={this.queryHandleChange}
                    className="btn btn-light d-flex align-items-center justify-content-center p-2"
                    title="Search"
                  >
                    <img
                      src="assets/images/search.svg"
                      alt="Search"
                      style={{ width: "1.125rem", height: "1.125rem" }}
                    />
                  </button>
                </div>
              </div>

              {/* Generate Report */}
              <div className="col-sm-1">
                <button
                  className="btn navyblue-btn w-100"
                  id="generateReport"
                  title="Generate Report"
                  disabled={this.state.diableDownloadButton}
                  onClick={this.generateReport}
                  style={{ fontSize: "1rem" }}
                >
                  Generate Report
                </button>
              </div>

              {/* Refresh */}
              <div className="col-sm-1">
                <button
                  className="btn action-button d-flex align-items-center justify-content-center"
                  title="Refresh"
                  onClick={this.refreshData}
                  style={{ width: "40%" }}
                >
                  <img
                    src="./assets/images/refresh_white_24dp.png"
                    alt="Refresh"
                    style={{ width: "1.25rem", height: "1.25rem" }}
                  />
                </button>
              </div>
            </div>
          </div>
          {/* /.content-header */}
          <div className="content" style={{ marginTop: "0.625rem" }}>
            <div className="container-fluid">
              <div className="row" style={{ marginRight: "2%" }}>

                {/* Left Table Card */}
                <div className="col-lg-6">
                  <div
                    className="card"
                    style={{
                      height: "40rem",
                      overflowY: data.length > 4 ? "auto" : "hidden",
                    }}
                  >
                    <ReactTable
                      style={{
                        display: this.state.successResp ? "block" : "none",
                      }}
                      data={data}
                      columns={columns}
                      pageSize={data.length > 5 ? data.length : 5}
                      showPagination={false}
                      showHeader={false}
                      noDataText={
                        <div style={{ textAlign: "center", padding: "2rem" }}>
                          <img
                            src="./assets/images/warn.svg"
                            alt="No data"
                            style={{ height: "3rem", width: "3rem", marginBottom: "1rem" }}
                          />
                          <div className="fw-bold mb-2" style={{ fontSize: "1.25rem" }}>
                            No Conversations Found
                          </div>
                        </div>
                      }
                    />
                  </div>

                  {/* Toast Notification */}
                  <ToastContainer className="Toast-at-center" />
                </div>

                {/* Right Table Card */}
                <div className="col-lg-6">
                  <div
                    className="card"
                    style={{
                      height: "40rem",
                      overflowY: "auto",
                    }}
                  >
                    <div className="table-responsive logTableBox">
                      <ReactTable
                        id="reactTable"
                        data={this.state.leadUtteranceListJsonModel}
                        columns={columns1}
                        showPagination={false}
                        showHeader={false}
                        pageSize={
                          this.state.leadUtteranceListJsonModel.length <= 5
                            ? 5
                            : this.state.leadUtteranceListJsonModel.length
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
export default ConversationLog;



// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/ConversationLog.js